export default "/images/vendor/quill/icons/superscript.svg?3bed5966c174cea3f1047990c82290a3";